<template>
  <path
    fill="currentColor"
    d="M10.625 1.94897C10.625 1.6038 10.3452 1.32397 10 1.32397C9.65482 1.32397 9.375 1.6038 9.375 1.94897V9.375H1.94897C1.6038 9.375 1.32397 9.65482 1.32397 10C1.32397 10.3452 1.6038 10.625 1.94897 10.625H9.375V18.051C9.375 18.3962 9.65482 18.676 10 18.676C10.3452 18.676 10.625 18.3962 10.625 18.051V10.625H18.051C18.3962 10.625 18.676 10.3452 18.676 10C18.676 9.65482 18.3962 9.375 18.051 9.375H10.625V1.94897Z" />
</template>
